import { Reveal } from "./Reveal";
import { PullQuote } from "./PullQuote";
import { GoogleStars } from "./GoogleStars";
import { trackEvent } from "../lib/tracking";
import {
  GOOGLE_PROFILE_URL,
  GOOGLE_RATING,
  GOOGLE_REVIEW_COUNT,
} from "../lib/googleReviews";

// Supporting reviews, quoted VERBATIM from the official Google Business
// Profile ("The Nurtured Parent Collective"). Never edit the wording —
// to rotate a review, copy the replacement word-for-word from the profile.
const MORE_GOOGLE_REVIEWS = [
  {
    testid: "review-brianna",
    quote:
      "We reached out to Andrea because our baby was struggling with independent sleep, our baby was sleeping alone in basinet for stretches until 4 months when I started back at work. The long nights and constant feeds made it nearly impossible for us to get any rest. Andrea provided us with a sleep plan that was easy to follow and tailored to our baby's needs. Within a few weeks, we saw significant improvements, and our baby was sleeping through the night! We are so grateful for her help!",
    name: "Brianna Talley",
  },
  {
    testid: "review-natalie",
    quote:
      "Andrea started with our family when our daughter was 4 weeks old, and she was such a blessing during those early weeks. She was always punctual, reliable, and communicative, and we looked forward to having her each night. She not only took care of our daughter but also helped us with tips and support that made the transition to parenthood smoother. I can't recommend her enough!",
    name: "Natalie Moreno Gray",
  },
];

// Verified Google proof, immediately before the offer: the small Google
// label + static rating snapshot, Jaye's curated lead quote, then more real
// Google reviews — all linking out to the official profile.
export const JayeProof = () => (
  <section data-testid="jaye-proof-section" className="bg-ivory">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20 py-20 lg:py-28">
      <Reveal>
        <p className="text-xs tracking-[0.25em] uppercase font-semibold text-clay">
          Google Reviews
        </p>
        <h2
          data-testid="reviews-heading"
          className="mt-6 font-serif font-light text-ink text-4xl sm:text-5xl leading-[1.08] tracking-tight"
        >
          What parents are saying.
        </h2>
        <p
          data-testid="reviews-rating-line"
          className="mt-6 flex flex-wrap items-center gap-x-2.5 gap-y-2 text-xs tracking-[0.18em] uppercase font-semibold text-ink/70"
        >
          <GoogleStars size={13} />
          {GOOGLE_RATING} on Google · {GOOGLE_REVIEW_COUNT} reviews
        </p>
      </Reveal>

      <div className="mt-14 lg:mt-20">
        <PullQuote
          testid="review-jaye"
          big
          quote="We are so happy with the results we achieved working with Andrea! Our daughter is now able to fall asleep independently, is sleeping much better, and can put herself back to sleep if she wakes during the night."
          name="Jaye Scheid"
        />
      </div>

      <div className="mt-16 lg:mt-24 grid gap-14 lg:gap-16 md:grid-cols-2 border-t border-ink/10 pt-14 lg:pt-16">
        {MORE_GOOGLE_REVIEWS.map((review) => (
          <PullQuote
            key={review.testid}
            testid={review.testid}
            quote={review.quote}
            name={review.name}
          />
        ))}
      </div>

      <Reveal className="mt-14 lg:mt-20">
        <a
          data-testid="read-all-reviews-google"
          href={GOOGLE_PROFILE_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            trackEvent("google_reviews_click", { location: "reviews_section" })
          }
          className="inline-flex items-center gap-2.5 rounded-full border border-ink/25 px-7 py-3.5 text-xs tracking-[0.18em] uppercase font-semibold text-ink transition-colors hover:bg-ink hover:text-ivory"
        >
          Read All Reviews on Google
          <span aria-hidden="true">→</span>
        </a>
      </Reveal>
    </div>
  </section>
);
